import React from 'react';
import { Table, Text, EmptyState } from '@clockout-dev/design-elements';
import {
    ENROLLMENT_STATUS,
    ENROLLMENT_STATUS_CLASS,
} from '../../dashboard/dashboard.constants';
import styles from './styles/user-summary-table.module.scss';

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (name) => <Text as="span" size="s" className={styles.cellStrong}>{name || '—'}</Text>,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (value) => <Text as="span" size="s" className={styles.cellMuted}>{value || '—'}</Text>,
    },
    {
        title: 'Enrollment Status',
        dataIndex: 'enrollmentStatus',
        key: 'enrollmentStatus',
        render: (status) => {
            const config = ENROLLMENT_STATUS[status] || { label: status };
            const className = ENROLLMENT_STATUS_CLASS[status] || styles.statusTc;
            return (
                <span className={`${styles.enrollmentStatus} ${className}`}>
                    {config.icon}
                    {config.label}
                </span>
            );
        },
    },
    {
        title: 'Opted-In Date',
        dataIndex: 'createdDate',
        key: 'createdDate',
        render: (value) => <Text as="span" size="s" className={styles.cellMuted}>{value}</Text>,
    },
    {
        title: 'Acct. Last 4',
        dataIndex: 'last4',
        key: 'last4',
        render: (value) => <Text as="span" size="s" className={styles.cellMuted}>{value}</Text>,
    },
];

function UserSummaryTable({ rows = [], loading = false, pageInfo = null, onTableChange }) {
    return (
        <Table
            columns={columns}
            dataSource={rows}
            loading={loading}
            pageInfo={pageInfo || null}
            onChange={onTableChange}
            saveSearchParams
            rowKey="key"
            emptyState={<EmptyState title="No users for this period." />}
        />
    );
}

export default UserSummaryTable;
